import { MessageCircle, MessageSquare } from "lucide-react";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import ThreadsList from "./thread-list/threadsList";
import ThreadDetails from "./thread-details/threadDetails";
import { useThreads } from "./useThreads";
import { setSelectedThreadId } from "./messagingThreadSlice";

const Threads: React.FC = () => {
  const { threadId } = useParams<{ threadId?: string }>();
  const dispatch = useDispatch();
  const { selectedThreadId } = useThreads();

  useEffect(() => {
    if (threadId) {
      dispatch(setSelectedThreadId(threadId));
    }
  }, [threadId, dispatch]);

  return (
    <div className="fullScreen h-full">
      <div className="container !h-full">
        <div className="savedFiltersScreen h-full pb-[75px] gap-3 mt-[20px] block">
          <div className="sfTitles flex flex-col items-start justify-between">
            <div className="flex flex-row gap-2 items-center">
              <MessageSquare className="h-8 w-8 text-[var(--primary-700)]" />
              <h2 className="display-sm semibold gray-900">Messages</h2>
            </div>
          </div>

          <div className="w-full h-full flex flex-row bg-white rounded-b-2xl">
            <div className="w-[30%] border-r border-gray-300">
              <ThreadsList />
            </div>

            <div className="w-[70%] h-full">
              {selectedThreadId ? (
                <ThreadDetails />
              ) : (
                <div className="h-full flex flex-col items-center justify-center text-center text-gray-500 gap-4">
                  <div className="p-4 rounded-full bg-primary-50">
                    <MessageCircle className="h-10 w-10 text-[var(--primary-700)]" />
                  </div>

                  <div>
                    <p className="text-base font-medium text-gray-700">
                      No conversation selected
                    </p>
                    <p className="text-sm text-gray-500">
                      Select a chat to see messages
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Threads;
